import { Button, ButtonProps } from '@mui/material';
import React from 'react';

import { useWizardBack } from '../wizard-page';

type Props = Pick<ButtonProps, 'size' | 'fullWidth'>;

const BackButton: React.FC<Props> = ({ size = 'large', fullWidth = true }: Props) => {
  const handleBack = useWizardBack();

  if (!handleBack) {
    return null;
  }

  return (
    <Button variant="outlined" color="primary" size={size} fullWidth={fullWidth} onClick={handleBack}>
      Back
    </Button>
  );
};

export { BackButton };
